'use strict';
// 21.1.3.25 String.prototype.trim()
require(102)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});